import axios from 'axios';
import qs from 'qs';
import {PRICING_API_URL} from '../../constants';
import {FetchPricePayload, FetchPriceFulfilledPayload} from './types';
import {ValidJoinServicesRequest, createAxiosError, getMockCurrentDate} from '../utils';
import {AxiosResponse, AxiosError} from '../types';
import {captureMessage} from '@sentry/gatsby';

export const fetch = async (parameters: FetchPricePayload) => {
  try {
    const mockedCurrentDate = getMockCurrentDate();
    if (mockedCurrentDate) {
      parameters.effectiveDate = mockedCurrentDate;
    }
    const res = await axios.get<any>(`${PRICING_API_URL}?${qs.stringify(parameters, {skipNulls: true})}`, {validateStatus: ValidJoinServicesRequest});
    const response: AxiosResponse<FetchPriceFulfilledPayload> = {
      data: res.data.data,
      type: 'Price'
    };
    return response;
  } catch (error) {
    const response: AxiosResponse<AxiosError> = {
      type: 'AxiosError',
      data: createAxiosError(error, 'GET')
    };
    captureMessage(`[WJW7] - fetch price error -- ${response.data.message}`, 'error');
    return response;
  }
};
